
export default {
	name: 'DefaultParameter',
	props: {
		type: {
			type: String,
			required: true,
		},

		id: {
			type: String,
			required: true,
		},

		name: {
			type: String,
			required: true,
		},

		link: {
			type: String,
			default: '',
		},
	},
}
